import React, { Component } from 'react';
import CustomerProjects  from '../presentation/customer-projects';

class CustomerProjectsWidget extends Component {
    state = {
        projects: [],
        configParams: []
    }
 
    componentDidMount() {
        const accountId = this.props.id
        this.getConfigurationParams()
        this.loadProjectsFromServer(accountId)
    }

    loadProjectsFromServer(accountId) {
        fetch(`/service/${accountId}/projects`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            if( response.status != 200 ) {
                response.json().then(json => this.handleError(json, this));
            } else {
                response.json().then(projects => this.setState({ projects }))
            }
        });
    }

    getConfigurationParams() {
        fetch("/service/configurationParams/", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
          credentials: "same-origin",
        }).then((response) => {
          if (response.status !== 200) {
            response.json().then((error) => console.error("Error =>", error));
          } else {
            response.json().then((configParams) => {
              this.setState({ configParams });
            });
          }
        })
      }

    render() {
        return <CustomerProjects
                    accountId={this.props.id} 
                    projects={this.state.projects}
                    configParams={this.state.configParams}
                />
    } // render
}; // CustomerProjectsWidget


export default CustomerProjectsWidget;